import cxs from 'cxs';

const ERROR_TOOLTIP = (COLOUR, TEXT) => cxs({
  backgroundColor: `${COLOUR} !important`,
  color: `${TEXT} !important`,
  '.place-right:after': {
    borderRightColor: COLOUR
  },
  '.place-bottom:after': {
    borderBottomColor: COLOUR
  },
  '.place-top:after': {
    borderTopColor: COLOUR
  },
  '.place-left:after': {
    borderLeftColor: COLOUR
  },
  fontSize: '10px',
  padding: '15px',
  opacity: '1 !important'
});

export default ERROR_TOOLTIP;